<div class="display-value">
  <display-value [inputData]="inputData.start"></display-value>
  <display-value class="display-value-end" [inputData]="inputData.end"></display-value>
</div>
<div class="progress-with-text">
  <progress-bar [progress]="inputData.progressValue"></progress-bar>
</div>

